<template>
    <div>
        <b-navbar toggleable="md" type="dark" variant="info"
                  class="app-header d-flex flex-row" fixed="top">
            <button class="collapse-cover"
                    @click="toggleSidebarState">
                <i class="fas fa-angle-double-right" v-if="showCollapse"></i>
                <i class="fas fa-angle-double-left" v-else></i>
            </button>
            <b-navbar-toggle target="header_menu_collapse" class="ml-1 mr-auto"></b-navbar-toggle>

            <!--            <b-navbar-brand-mintal href="#" class="app-mintal__log">-->
            <slot name="logo"></slot>
            <!--            </b-navbar-brand-mintal>-->
            <!--      <b-navbar-brand-mintal href="#" class="app-mintal__log"><slot name="logo_mintal"></slot></b-navbar-brand-mintal>-->
            <!--      <b-navbar-brand href="#" class="app-header__logo"><slot name="logo"></slot></b-navbar-brand>-->

            <b-collapse is-nav id="header_menu_collapse" class="nav-items-cover">
                <b-navbar-nav class="ml-auto flex-row">
                    <!--          <b-nav-form>-->
                    <!--                      <div class="app-search">-->
                    <!--                          <input class="app-search__input" type="search" :placeholder="$t('btn.basic.search')">-->
                    <!--                          <button class="app-search__button"><i class="fa fa-search"></i></button>-->
                    <!--                      </div>-->
                    <!--          </b-nav-form>-->
                    <screenfull id="screenfull" class="app-nav__item"/>

                    <b-nav-item-dropdown class="m-tb-auto" no-caret right :disabled="notificationDisabled">
                        <template slot="button-content">
                            <span class="app-nav__item">
                            <!--小喇叭-->
                            <i class="fa fa-bell fa-lg"/>
                                <!--新消息数量badge-->
                            <span
                                v-show="notificationsNew > 0"
                                class="badge badge-danger app-notification_badge"
                            >{{ notificationsNew }}</span>
                          </span>
                        </template>
                        <div role="group" aria-labelledby="header1" class="app-notification">
                            <span class="dropdown-item app-notification__title">
                                You have {{ notificationsNew }} new notifications.
                                <!--删除全部消息-->
                                <a
                                    v-show="notifications.length > 0"
                                    class="app-notification__delete"
                                >
                                  <i class="fas fa-trash-alt" v-on:click="deleteAll"></i>
                                </a>
                              </span>
                            <div
                                class="app-notification__content"
                                ref="notifContainer"
                            >
                                <!--                  v-on:scroll.passive="handleScroll()"-->

                                <!--每条通知的链接-->
                                <b-link
                                    v-for="notification in notifications"
                                    :key="notification.id * Math.random()"
                                    v-on:click="openNotification(notification)"
                                    class="app-notification__item"
                                >

                                    <!--根据通知不同状态，显示不同图标-->
                                    <div class="app-notification__item__icon">
                                        <!--新消息图标-->
                                        <i v-show=" notification.status === 'N'"
                                           class="fas fa-circle text-danger pr-2 app-notification__iconPending"></i>
                                        <!--消息类型图标-->
                                        <!--report下载-->
                                        <i v-if=" notification.type === 'R' && (notification.link && notification.link.trim() !== '')"
                                           class="fas fa-file-download modal-icon text-primary fa-2x ml-2 pr-2"></i>
                                        <!--notification通知-->
                                        <i v-else class="fa fa-cog modal-icon text-secondary fa-2x ml-2 pr-2"></i>
                                    </div>
                                    <p class="app-notification__message">{{
                                            notification.title && notification.title.substring(0, 27)
                                        }}</p>
                                    <span
                                        class="app-notification__meta"
                                        :title="notification.content && notification.content"
                                    >{{ [notification.date] }}</span>
                                    <!--                  >{{ [notification.date] | moment("from") }}</span>-->
                                </b-link>
                            </div>
                        </div>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown class="m-tb-auto" trigger="link" size="lg" no-caret right>
                        <template slot="button-content">
                            <span class="app-nav__item">
                                <i class="fa fa-language fa-lg"/>
                            </span>
                        </template>
                        <b-dropdown-item command="ch" v-on:click="handleSetLanguage('ch')">
                            <a class="dropdown-item" href="#">中文</a>
                        </b-dropdown-item>
                        <b-dropdown-item command="en" v-on:click="handleSetLanguage('en')">
                            <a class="dropdown-item" href="#">English</a>
                        </b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown class="m-tb-auto" variant="link" size="lg" no-caret right>
                        <template slot="button-content">
                            <span class="app-nav__item">
                                <i class="fa fa-user fa-lg"/>
                            </span>
                        </template>
                        <b-dropdown-item>
                            <router-link to="/em/emUserCenter" class="dropdown-item">
                                <i class="fa fa-user fa-lg"></i>
                                {{ $t("app.profile") }}
                            </router-link>
                        </b-dropdown-item>
                        <b-dropdown-item href="#">
                            <a class="dropdown-item" href="page-login.html" v-on:click="logout">
                                <i class="fa fa-sign-out-alt fa-lg"></i>
                                {{ $t("app.logout") }}
                            </a>
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
// import Push from 'push.js'

import Screenfull from "@/components/Screenfull";
import emWebSocketMixin from "@/mixin/em/common/webSocket";
import EmCommonApi from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import {mapState} from "vuex";

export default {
    name: "em-header",
    mixins: [emWebSocketMixin, EmCommonApi],
    props: ["baseApiUrl", "userId"],
    components: {
        Screenfull,
    },
    data: function () {
        return {
            maxNotificationsPage: 99,
            actualPage: 0,

            notificationDisabled: false,
            notifications: [],
            notificationsNew: 0,
            refreshIntervalId: null,

            readNotificationsLock: false, // 请求锁

            subscribeItem: {
                id: "headerNotification",
                topic: "headerNotification", callback: (responseBody) => {
                    this.$store.commit("emMenu/setNewNotification", JSON.parse(responseBody.body))
                    this.findReadNotifications();
                    this.findNewToBadge();
                }
            },
            currentPopup: new Set(),
        };
    },
    computed: {
        ...mapState({
            showCollapse: state => state.base.showCollapse,
        }),
    },
    mounted() {
        //通过监听发现不用手动关闭stomp连接。刷新或关闭浏览器，会自动断开连接。但这里的监控窗口关闭的方法可以先留着。
        Notification.requestPermission().then(() => {
            this.notificationDisabled = false;
            //如果webSocket已连接了，直接订阅就好
            if (this.$webSocket.isConnected()) {
                // 订阅点对点通知
                this.$webSocket.subscribeToBroadcast(this.subscribeItem)
                // 订阅广播消息
                this.$webSocket.subscribeToPoint(this.subscribeItem)
            }
            //否则就初始化webSocket
            else {
                this.$webSocket.init({
                    successCallback: () => {
                        this.findReadNotifications();
                        this.findNewToBadge();
                        // 订阅点对点通知
                        this.$webSocket.subscribeToBroadcast(this.subscribeItem)
                        // 订阅广播消息
                        this.$webSocket.subscribeToPoint(this.subscribeItem)
                    },
                    //连接失败就主动查询通知
                    errorCallback: () => {
                        this.findReadNotifications();
                        this.findNewToBadge();
                    }
                })
            }
        }).catch((e) => {
            console.info(e)
            console.info("Permission NOT allowed by the browser");
            // this.$webSocket.disconnect()
            this.$webSocket.unsubscribeToPoint(this.subscribeItem.id)
            this.$webSocket.unsubscribeToBroadcast(this.subscribeItem.id)
            // this.$_emWebSocketMixin_disconnect()
            // me.disconnectNotificationWS();
            this.notificationDisabled = true;
            this.notifications = [];
        });
    },
    destroyed() {
        this.$webSocket.unsubscribeToPoint(this.subscribeItem.id)
        this.$webSocket.unsubscribeToBroadcast(this.subscribeItem.id)
    },

    methods: {
        toggleSidebarState: function () {
            this.$store.commit('base/setShowCollapse', !this.showCollapse);
        },
        beforeunloadHandler() {
            this._beforeUnload_time = new Date().getTime();
        },
        unloadHandler(e) {
            this._gap_time = new Date().getTime() - this._beforeUnload_time;
            debugger
            //判断是窗口关闭还是刷新
            if (this._gap_time <= 5) {
                //如果socket还连着，就断掉
                this.$webSocket.disconnect()
            }
        },
        handleScroll() {
            let compo = this.$refs.notifContainer;
            let height = compo.scrollHeight - compo.clientHeight; // Get the height of the div
            let scroll = Math.ceil(compo.scrollTop);

            if (scroll >= height) {
                this.findReadNotifications();
            }
        },
        findReadNotifications(callback) {
            if (this.readNotificationsLock) {
                return;
            }
            this.readNotificationsLock = true;

            let data = {
                firstReg: this.actualPage,
                numRegPag: this.maxNotificationsPage,
            };
            let url = `${this.$_emApiMixin_entityBaseApi("emAdmNotification")}/findAllByUser`;
            // 释放锁
            const releaseLock = () => {
                this.readNotificationsLock = false;
            };
            return this.$store
                .dispatch("api/post", {url, data})
                .then((json) => {
                    // me.notifications = me.notifications.concat(json.data.list);
                    this.notifications = Object.assign([], json.data.list);
                    this.scrollIsBusy = false;

                    this.popupNotifications();

                    if (callback) {
                        callback(json.data);
                    }
                    return json;
                })
                .then((v) => {
                    releaseLock();
                    // this.actualPage++;
                    return v;
                })
                .catch(releaseLock);
        },
        popupNotifications() {
            if (this.notifications.length > 0) {
                let tempList = [];
                for (let item of this.notifications) {
                    if (item.status === 'N' && item.style && !this.currentPopup.has(item.id)) {
                        tempList.push(item);
                    }
                }
                tempList.reverse();

                for (let item of tempList) {
                    let styles = JSON.parse(item.style);
                    if (styles.popup === true) {
                        let h = this.$createElement
                        let header = h(
                            'div',
                            {class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2']},
                            [
                                h('strong', {class: 'mr-2'}, item.title),
                                h('small', {class: 'ml-auto text-italics'}, item.date)
                            ]
                        );
                        let body = h('div',
                            {
                                class: ['d-flex flex-column', item.link ? 'cursor-pointer' : ''],
                                on: {
                                    click: () => this.openNotification(item)
                                }
                            },
                            [item.content]);
                        this.$bvToast.toast([body], {
                            id: 'POPUP' + item.id,
                            title: [header],
                            variant: styles.popup_variant,
                            solid: true,
                            noAutoHide: !styles.popup_auto_hide,
                        });
                        this.currentPopup.add(item.id);
                    }
                }
            }
        },
        handleSetLanguage(lang) {
            this.$i18n.set(lang);
        },

        logout() {
            this.$authentication.logout(this.$store);
        },
        openNotification(notification) {
            //跳转
            if (notification.link && (notification.link + "").trim() !== "") {
                //report下载
                if (notification.type === "R") {
                    let url = notification.link;
                    if (url && !url.startsWith("http")) {
                        url = process.env.VUE_APP_REPORT_API_URL + url;
                    }
                    let fileName = notification.content;
                    this.$store.dispatch("api/getTemplateDownload", {url, fileName});
                }
                //站内
                else if (notification.type === "I") {
                    this.$router.push(notification.link)
                }//站外
                else if (notification.type === "E") {
                    window.location.href = notification.link
                }
            }

            if (notification.status !== "N" && notification.status !== "S") return;
            this.markNoticeRead(notification.id);
        },
        markNoticeRead(id) {
            let me = this;
            let url = `${this.$_emApiMixin_entityBaseApi("emAdmNotification")}/markAsRead/${id}`;
            this.$store.dispatch("api/post", {url}).then(function () {
                me.notificationsNew--;
                let matchNotification = me.notifications.filter(f => f.id === id)
                matchNotification[0].status = "R"
                me.hideToast(id);
            });
        },
        hideToast(id) {
            this.currentPopup.delete(id);
            this.$bvToast.hide('POPUP' + id);
        },
        showNotifications(notif) {
            let msg = new SpeechSynthesisUtterance(notif[0].title);
            msg.voiceURI = "Google 普通话（中国大陆）";
            msg.lang = "zh-CN";
            window.speechSynthesis.speak(msg);
            notif.forEach((notification) => {
                let browserNotification = new Notification(notification.title, {
                    body: notification.content,
                    link: notification.link,
                    vibrate: [200, 100, 200, 100, 200, 100, 200],
                    timeout: 20000,
                });
                browserNotification.onclick = function () {
                    window.focus();
                    if (notification.link && (notification.link + "").trim() !== "") {
                        window.open(notification.link);
                    }
                };
            });
        },
        findNewToBadge() {
            let url = `${this.$_emApiMixin_entityBaseApi("emAdmNotification")}/findNewCount`;

            // let url = this.baseApiUrl + "adm-service/adm/notification/findNewToBadge/";
            this.$store.dispatch("api/get", {url}).then((json) => {
                this.notificationsNew = json;
            });
        },
        deleteAll() {
            let me = this;
            let url = `${this.$_emApiMixin_entityBaseApi("emAdmNotification")}/deleteAll`;
            // let url = this.baseApiUrl + "adm-service/adm/notification/deleteAll/";
            this.$store.dispatch("api/delete", {url}).then(() => {
                me.notifications = [];
                this.notificationsNew = 0;
                commonViewsUtil.showSuccess(this, "通知已清空")
            });
        },
        //改为调用mixin
        connectNotificationWS() {
            let me = this;
            // var interval;
            // interval = window.setInterval(function () {
            // var token = me.$store.state["auth"].token;
            // var token = localStorage['em_sso_token'];
            if (token) {
                // var bearerToken = "Bearer " + token;
                var bearerToken = token;
                var urlMod =
                    me.baseApiUrl + "adm-service/ws-mmf-stomp?access_token=" + token;
                me.socket = new SockJS(urlMod);
                me.stompClient = Stomp.over(me.socket);
                me.stompClient.connect(
                    {},
                    (frame) => {
                        me.stompClient.subscribe("/queue/errors", (message) => {
                            console.log(message);
                            console.log(frame);
                        });

                        me.stompClient.subscribe("/queue/notification", (message) => {
                            var data = JSON.parse(message.body);
                            me.notifications = [...data, ...me.notifications];
                            me.notificationsNew = me.notificationsNew + data.length;
                            me.showNotifications(data);
                        });

                        me.stompClient.send(
                            "/app/register",
                            {Authorization: bearerToken},
                            ""
                        );
                    },
                    (error) => {
                        console.log(error);
                    }
                );
                if (interval) {
                    window.clearInterval(interval);
                }
            }
            // }, 1000);
        },
        //改为调用mixin
        disconnectNotificationWS() {
            if (this.stompClient) {
                this.stompClient.disconnect();
            }
        },
    },
};
</script>

<style>
.b-toaster.b-toaster-top-right {
    top: 2.5rem !important; /*避免toast遮挡header*/
}
</style>

<style scoped lang="scss">
.collapse-cover {
    padding: 0.25rem 0.75rem;
    font-size: 0.9875rem;
    line-height: 1;
    background-color: transparent;
    border-radius: 3px;
    color: rgba(255, 255, 255, 0.5);
    border-color: rgba(255, 255, 255, 0.1);
}

@media (min-width: 768px) {
    .collapse-cover {
        display: none;
    }
}

@media (max-width: 767px) {
    .nav-items-cover {
        background-color: rgb(64, 71, 76);
    }
}
</style>
